import React from "react";
import { PeekFormControl, PeekFormLabel, PeekToggleSwitch } from "@piiqtechnologies/ui-components";
const ToggleSwitch = ({ field, form, label, onLabel, offLabel }) => {
    return (React.createElement(PeekFormControl, { fullWidth: true },
        React.createElement(PeekFormLabel, { sx: { mb: 1 } }, label),
        React.createElement(PeekToggleSwitch, { color: "primary", offProps: {
                label: offLabel,
                value: false,
            }, onProps: {
                label: onLabel,
                value: true,
            }, value: field.value, 
            //@ts-ignore
            onChange: (value) => form.setFieldValue(field.name, value) })));
};
export default ToggleSwitch;
